import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'prodingsPipe'
})
export class ProdingsSelectPipe implements PipeTransform {
    transform(prodings: any, term?: any): any {

        if (term === undefined) return prodings;
        if (term === null) return prodings;

        if (prodings != null) {
            return prodings.filter(function (proding) {
                if (proding.name != undefined)
                    if (proding.name.toLowerCase().includes(term.toLowerCase()))
                        return proding;


            })
        }


    }
}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-partial-ingprod-select/prodings-select-pipe.ts